export default __webpack_public_path__ + "static/media/ok_black.45dcd5c6.svg";